// extracted by mini-css-extract-plugin
export default {"TextArea":"FancyTextArea_TextArea__cbjQg","Focused":"FancyTextArea_Focused__2FqXk","Shifted":"FancyTextArea_Shifted__kBjqo"};